import InfoRoundIcon from '@rsuite/icons/InfoRound';

export const NotFoundPage: React.FC = () => {
  return (
    <div className="flex justify-center items-center min-h-[60vh] p-8">
      <div className="text-center max-w-md">
        <div className="mb-6">
          <InfoRoundIcon
            style={{
              fontSize: '40px',
              color: '#3498db',
              opacity: 0.8,
            }}
          />
        </div>

        <h2
          data-testid="not-found-component-title"
          className="text-2xl font-medium mb-6"
        >
          Page Not Found
        </h2>
        <p className="text-gray-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have
          been moved or deleted.
        </p>
      </div>
    </div>
  );
};
